import { z } from 'zod';

import { mongoIdSchema } from './shared';

export enum SeoStrategyKeywordAction {
  Create = 'create',
  Refresh = 'refresh',
}

/** Stored string values match `AuditKeywordFunnel` on audit hook payloads. BOFU = high business relevance, TOFU = low. */
export enum SeoStrategyKeywordFunnel {
  High = 'bofu',
  Medium = 'mofu',
  Low = 'tofu',
}

export enum SeoStrategyKeywordStatus {
  Draft = 'draft',
  InProgress = 'inProgress',
  Published = 'published',
}

export const seoStrategyKeywordCreateSchema = z.object({
  brandId: z.string(),
  seoStrategyId: z.string(),
  status: z.nativeEnum(SeoStrategyKeywordStatus),
  isGenerated: z.boolean(),
  name: z.string(),
  position: z.number().nullish(),
  volume: z.number(),
  competition: z.number(),
  url: z.string(),
  difficulty: z.number(),
  traffic: z.number(),
  trafficPercent: z.number(),
  intent: z.array(z.string()),
  origin: z.string(),
  funnel: z.nativeEnum(SeoStrategyKeywordFunnel),
  difficultyScore: z.number(),
  competitionScore: z.number(),
  feasibilityScore: z.number(),
  volumeScore: z.number(),
  rankOppScore: z.number(),
  businessScore: z.number(),
  finalScore: z.number(),
  action: z.nativeEnum(SeoStrategyKeywordAction),
});
export type SeoStrategyKeywordCreate = z.infer<typeof seoStrategyKeywordCreateSchema>;

export const seoStrategyKeywordSchema = z
  .object({
    _id: mongoIdSchema,
    createdAt: z.number(),
    updatedAt: z.number(),
    contentId: mongoIdSchema.nullish(),
  })
  .merge(seoStrategyKeywordCreateSchema);
export type SeoStrategyKeyword = z.infer<typeof seoStrategyKeywordSchema>;
